import { setOverlay } from "@/utils/overlayControl.js";
import { GetCurrentUserDetailsNewProd } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
import {
  isTrulyUnauthenticated,
  clearAppAuthState,
  resetAuthBootstrap,
} from "@/services/authSession.js";

const client = generateClient();

export const GetCurrentUser = {
  data() {
    return {
      getCurrentUserDetailsObject: {},
      overlay: false,
      user_type: "",
    };
  },
  methods: {
    async redirectIfUnauthenticated(reason, error) {
      const underlying = error?.underlyingError;
      console.warn("[auth] profile_fetch_error", {
        reason,
        name: error?.name,
        message: error?.message,
        underlyingName: underlying?.name,
        underlyingMessage: underlying?.message,
      });

      if (!(await isTrulyUnauthenticated())) {
        console.warn("[auth] profile_fetch_error_kept_session", { reason });
        return "ERROR";
      }

      console.warn("[auth] redirect_login", {
        reason,
        confirmedUnauthenticated: true,
      });
      clearAppAuthState(this.$store);
      resetAuthBootstrap();
      this.$router.push("/");
      return "ERROR";
    },

    async GetCurrentUser(route) {
      if (this.$store.getters.get_user_email != "") {
        try {
          setOverlay(this, true);

          // dev and prod both run the current (2026-10-05+) schema, which
          // dropped the input argument - see GetCurrentUserDetailsNewProd's
          // comment in graphql/queries.js.
          let result = await client.graphql({
            query: GetCurrentUserDetailsNewProd,
          });
          this.getCurrentUserDetailsObject = JSON.parse(
            result.data.GetCurrentUserDetails
          ).data.items[0];

          this.$store.commit(
            "SET_CURRENTUSER_DETAILS",
            JSON.parse(result.data.GetCurrentUserDetails).data.items[0]
          );
          if (route) {
            this.hasaccessRoutesList = [];
            let modulesHasAccessList = JSON.parse(
              result.data.GetCurrentUserDetails
            ).data.items[0].role_details.role_modules.filter(
              (item) => item.module_type == "ADMIN_PORTAL"
            );
            for (let i = 0; i < modulesHasAccessList.length; i++) {
              let module_rights = modulesHasAccessList[i].module_rights;
              let module_description =
                modulesHasAccessList[i].module_description.split("-")[0];
              let routeObject = {
                ...this.RouterList.filter(
                  (route) => route.MenuName == module_description
                )[0],
              };
              for (let key in routeObject) {
                modulesHasAccessList[i][key] = routeObject[key];
              }
              if (
                module_rights.view ||
                module_rights.create ||
                module_rights.edit ||
                module_rights.delete
              )
                modulesHasAccessList[i].hasVisibility = true;
              else modulesHasAccessList[i].hasVisibility = false;
            }
            let hasaccessRoutesList = modulesHasAccessList.filter(
              (route) => route.hasVisibility == true && route.module_index
            );
            this.hasaccessRoutesList = hasaccessRoutesList.sort(
              (a, b) => Number(a.module_index) - Number(b.module_index)
            );
            if (this.hasaccessRoutesList.length > 0) {
              this.hasaccessRoutesList[0].active = true;
              if (this.$route.name == "LandingPage") {
                this.$router.push(this.hasaccessRoutesList[0].MenuRoute);
              } else {
                let findRoute = this.hasaccessRoutesList.find(
                  (routeObj) => routeObj.MenuRoute == this.$route.name
                );
                if (findRoute) {
                  this.checkRouteMethod(findRoute);
                } else if (["SupportCases", "TrainingVideos"].includes(this.$route.name)) {
                  // Support Cases is outside the role-module menu (gated by
                  // getSupportAccess instead) - keep the user on it so email
                  // deep links survive a fresh load.
                  this.hasaccessRoutesList[0].active = false;
                } else {
                  await this.$router.push(
                    this.hasaccessRoutesList[0].MenuRoute
                  );
                }
              }
            } else {
              this.$router.push("/NoAccess");
            }

            this.$store.commit("SET_IS_REPORT_ISSUE_ROUTE", false);
          }
          setOverlay(this, false);
          return "SUCCESS";
        } catch (error) {
          setOverlay(this, false);
          return this.redirectIfUnauthenticated(
            "get_current_user_graphql_error",
            error
          );
        } finally {
          setOverlay(this, false);
        }
      } else {
        return this.redirectIfUnauthenticated("missing_vuex_email");
      }
    },
  },
};
